/**
 * This reducer is used for fetching shipping methods
 */
import {
    GET_SHIP_TO_ADDRESS,
    GET_SHIP_TO_ADDRESS_SUCCESS,
    GET_SHIP_TO_SEARCH_SUCCESS,
    GET_SHIP_TO_SEARCH_SUCCESS_TISSUE,
    GET_SHIP_TO_ADDRESS_FAILURE,
    GET_SHIP_TO_ADDRESS_RESET,
} from '../actions';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
const initialState = {
    shipToAddress: {},
    shipToAddressSearchResults: {},
    shipToAddressSearchResultsTissue: {},
    loading: false,
    statusCode: 0,
    statusMessage: '',
};

const shipToAddressReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_SHIP_TO_ADDRESS:
            return {
                ...state,
                shipToAddress: action.payload.searchTerm
                    ? { ...state.shipToAddress }
                    : [],
                shipToAddressSearchResults: [],
                shipToAddressSearchResultsTissue:[],
                loading: true,
            };
        case GET_SHIP_TO_ADDRESS_RESET:
            return {
                ...initialState
            };
        case GET_SHIP_TO_ADDRESS_SUCCESS:
            return {
                ...state,
                shipToAddress: {
                    ...state.shipToAddress,
                    ...action.payload,
                },
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_SHIP_TO_SEARCH_SUCCESS:
            return {
                ...state,
                shipToAddressSearchResults: {
                    ...state.shipToAddressSearchResults,
                    ...action.payload,
                },
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_SHIP_TO_SEARCH_SUCCESS_TISSUE:
            return {
                ...state,
                shipToAddressSearchResultsTissue: {
                    ...state.shipToAddressSearchResultsTissue,
                    ...action.payload,
                },
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };
        case GET_SHIP_TO_ADDRESS_FAILURE:
            return {
                ...state,
                shippingMethods: {},
                statusCode: action.statusCode,
                statusMessage: action.statusMessage,
                loading: false,
            };

        default: {
            return { ...state };
        }
    }
};

export default persistReducer(
    {
        key: 'equityShipToAddressKey',
        storage: storage,
    },
    shipToAddressReducer
);
